<template>
  <TableGradient
      icon-name="compact-disc"
      :title="$t('vns.listagem.titulo_pagina')"
      :text-empty="$t('vns.listagem.table.empty')"
      route-new="vns.create"
      :text-new="$t('vns.listagem.novo')"
      :fields="fields"
      :initial-fields="initial_fields"
      :fields-filter="filter"
      :items="vns"
      :paginator="paginator"
      :loading="isLoading"
      @list="evt => $store.dispatch('vns/listTable', evt)"
      table-data>
    <template v-slot:cell(modem_enable)="linha">
      <span
          :class="{'rounded-pill p-1 badge':true, 'badge-success':linha.item.modem_enabled, 'badge-danger': !linha.item.modem_enable}">
          {{ getEnableString(linha.item.modem_enabled) }}
      </span>
      <p class="m-0 small" v-if="linha.item.modem_serial">
          <span class="font-weight-bold">
              {{ $t('vns.listagem.table.modem.serial') }}:</span> {{ linha.item.modem_serial }}
      </p>
      <p class="m-0 small" v-if="linha.item.modem_company">
        <span class="font-weight-bold">
            {{ $t('vns.listagem.table.modem.empresa') }}:</span> {{ linha.item.modem_company }}
      </p>
      <p class="m-0 small" v-if="linha.item.modem_chip_number">
        <span class="font-weight-bold">
            {{ $t('vns.listagem.table.modem.chip') }}:</span> {{ linha.item.modem_chip_number }}
      </p>
    </template>
    <template v-slot:cell(modem_data_limit)="linha">
      <p class="m-0 small" v-if="linha.item.modem_data_limit">
        <span class="font-weight-bold">
            {{ $t('vns.listagem.table.modem.limit') }}:</span> {{ linha.item.modem_data_limit }}
      </p>
      <p class="m-0 small" v-if="linha.item.modem_data_alert">
        <span class="font-weight-bold">
            {{ $t('vns.listagem.table.modem.alerta') }}:</span> {{ linha.item.modem_data_alert }}
      </p>
      <p class="m-0 small" v-if="linha.item.modem_data_consumption">
        <span class="font-weight-bold">
            {{ $t('vns.listagem.table.modem.consumo') }}:</span> {{ linha.item.modem_data_consumption }}
      </p>
    </template>
    <template v-slot:cell(gps_enabled)="linha">
      <span
          :class="{'rounded-pill p-1 badge':true, 'badge-success':linha.item.gps_enabled, 'badge-danger': !linha.item.gps_enabled}">
          {{ getEnableString(linha.item.gps_enabled) }}
      </span>
      <p class="m-0 small" v-if="linha.item.gps_number">
        <span class="font-weight-bold">
            {{ $t('vns.listagem.table.numero_gps') }}:</span> {{ linha.item.gps_number }}
      </p>
    </template>
    <template v-slot:cell(temperature_sensor_enabled)="linha">
      <span
          :class="{'rounded-pill p-1 badge':true, 'badge-success':linha.item.temperature_sensor_enabled, 'badge-danger': !linha.item.temperature_sensor_enabled}">
          {{ getEnableString(linha.item.temperature_sensor_enabled) }}
      </span>
    </template>
    <template v-slot:cell(status)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.status, 'badge badge-danger': !linha.item.status}">
          {{ getEnableString(linha.item.status) }}
      </span>
    </template>
    <template v-slot:cell(monitor)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.monitor, 'badge badge-danger': !linha.item.monitor}">
          {{ getEnableString(linha.item.monitor) }}
      </span>
    </template>
    <template v-slot:cell(id)="linha">
      <router-link :id="`link-edit-${linha.index}`" :to="{ name: 'vns.edit', params: { id: linha.item.id }}" class="font-weight-bold">
        {{ $t('vns.listagem.table.editar') }}
      </router-link>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      vns: 'vns/all',
      paginator: 'vns/pagination',
      store_isLoading: 'vns/isLoading'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('vns.listagem.table.nome'), sortable: true},
        {key: 'company', label: this.$t('vns.listagem.table.empresa')},
        {key: 'integration_origin', label: this.$t('vns.listagem.table.integracao_origem')},
        {key: 'integration_destination', label: this.$t('vns.listagem.table.integracao_destino')},
        {key: 'modem_enable', label: this.$t('vns.listagem.table.modem.label')},
        {key: 'modem_data_limit', label: this.$t('vns.listagem.table.modem.consumo')},
        {key: 'gps_enabled', label: 'GPS'},
        {key: 'temperature_sensor_enabled', label: this.$t('vns.listagem.table.sensor_temperatura')},
        {key: 'state', label: this.$t('vns.listagem.table.estado')},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'monitor', label: this.$t('vns.listagem.table.monitor')},
        {key: 'id', label: this.$t('vns.listagem.table.acoes')}
      ],
      filter: [
        {key: 'name', label: this.$t('vns.listagem.table.nome')},
        {key: 'company', label: this.$t('vns.listagem.table.empresa')},
        {key: 'integration_origin', label: this.$t('vns.listagem.table.integracao_origem')},
        {key: 'integration_destination', label: this.$t('vns.listagem.table.integracao_destino')},
      ],
      initial_fields: [
        'name',
        'integration_origin',
        'integration_destination',
        'status',
        'id'
      ]
    }
  },
  methods: {
    ...mapActions([
      'vns/listTable'
    ]),
    getEnableString(value) {
      if (value) {
        return this.$t('vns.listagem.table.habilitado')
      }
      return this.$t('vns.listagem.table.desabilitado')
    }
  },
  mounted() {
    this['vns/listTable'](this.paginator)
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
